import React from 'react';
import { message, Space, Tag, Row, Col, Descriptions, Divider, Steps, Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import { httpClient } from "util/Api";
import { compareUIElementValue } from 'util/Compare';
import { config } from "util/config";
import * as globalFunction from 'util/GlobalFunction';
import { getSectionData } from "components/UIBuilder/Global/DataHelper";
import { LoadingOutlined, SmileOutlined, SolutionOutlined, UserOutlined } from '@ant-design/icons';

export default class JobStatusStepperDiv extends React.Component {
  constructor(props) {
    super();
    this.state = {
      current: 0,
      steps: [],
      shouldUseVertical: false,
      screenWidth: window.innerWidth,
    }
  }

  //获取div数据
  componentDidMount() {
    if (this.props.section.autoLoad) {
      this.getJobStatusStepper();
    }
    window.addEventListener('resize', this.handleResize);
    this.setState({ shouldUseVertical: (this.state.steps.reduce((sum, step) => sum + step.title.length, 0) * 14 + this.state.steps.length * 50) > this.state.screenWidth });
  }

  getJobStatusStepper() {
    let that = this;
    let url = '';
    if (this.props.pageComponent.props.accessCode != undefined) {
      url = '/Admin/JobStatusStepper/GetPublicList?accessCode=' + this.props.pageComponent.props.accessCode;
    } else {
      url = '/Admin/JobStatusStepper/GetList?jobId=' + this.props.pageComponent.state.jobData.JobId;
    }
    httpClient
      .get(url)
      .then(({ data }) => {
        if (data.result) {
          let stepsList = []
          data.data.map((k, index) => {
            k.IconActiveUrl = 'data:image/svg+xml;base64, ' + k.IconActive;
            k.IconInactiveUrl = 'data:image/svg+xml;base64, ' + k.IconInactive;
            if (k.key === this.props.pageComponent.state.jobData.WorkflowStatus.JobStatusStepperId) {
              this.setState({ current: index })
            }
            stepsList.push({
              title: k.Name,
              description: k.Description,
              finish: k.IconActiveUrl,
              process: k.IconInactiveUrl,
            })
          })
          this.setState({ steps: stepsList })
        } else {
          globalFunction.handleResultError(data, this);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, that);
      });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.screenWidth !== this.state.screenWidth || prevState.steps.length !== this.state.steps.length) {
      this.setState({ shouldUseVertical: (this.state.steps.reduce((sum, step) => sum + step.title.length, 0) * 14 + this.state.steps.length * 50) > this.state.screenWidth });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    this.setState({ screenWidth: window.innerWidth })
  };


  getSectionDataByDefault() {
    getSectionData({ component: this });
  }

  render() {
    return (
      <Steps
        current={this.state.current}
        responsive={true}
        className="custom-Steps"
        style={{ display: 'flex', justifyContent: 'center' }}
        direction={this.state.shouldUseVertical ? 'vertical' : 'horizontal'}>
        {this.state.steps.map((step, index) => (
          <Steps.Step
            key={index}
            title={(
              <Tooltip title={step.description}>
                <div
                  style={{
                    whiteSpace: 'normal',
                    wordBreak: 'break-all',
                    maxWidth: '230px',
                    lineHeight: '1.5',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                  }}
                >
                  {step.title}
                </div></Tooltip>)}
            icon={this.state.current >= index ? <Tooltip title={step.description}><img style={{ width: '48px', marginRight: '4px' }} src={step.finish} alt={step.title}
            /></Tooltip> : <Tooltip title={step.description}><img style={{ width: '48px', marginRight: '4px' }} src={step.process} alt={step.title}
            /></Tooltip>}
          />
        ))}
      </Steps>
    )
  }
}
